import React from 'react';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { UserMembersActionType, UserMembersTranslation } from '../constants';
import { ListBranch, ListBranchState, Visibility } from '../types-store';
import { RowSelection } from '../types';
import { UserMembersListItem } from './user-members-list-item';
import { UserMembersListItemsContainer } from './user-members-list-items-container';
import { getCurrentBranchItems } from 'app/area/subscriber-groups/user-members/utils/get-current-branch-items';
import { UserMembersItemRow } from 'app/area/subscriber-groups/user-members/components/user-members-item-row';

interface UserMembersListItemsProps {
  listBranch: ListBranch[];
  listBranchState: ListBranchState[];
  visiblity: Visibility;
  checkedValues: { [id: number]: boolean };
  selectedRows: number[][];
  path: number[];
  isZebra: boolean;
  translation: UserMembersTranslation;
  selectRow: (selection: RowSelection) => void;
  addAction: (path: number[], type: UserMembersActionType, propagate: boolean) => void;
  loadFromParent: (id: number, startIndex: number) => void;
}

export const UserMembersListItems: React.FC<UserMembersListItemsProps> = ({
  listBranch, listBranchState, visiblity, checkedValues, selectedRows,
  path, isZebra, selectRow, addAction, loadFromParent, translation
}) => {

  const id = path.length > 0 ? path[path.length - 1] : 0;
  const currentBranch = listBranch.find(branch => branch.id === id);
  const currentBrunchItems = getCurrentBranchItems(id, listBranch, checkedValues, visiblity);
  const currentBranchState = listBranchState.find(branch => branch.id === id);
  const fetching = !!currentBranchState?.fetching;

  return <>
    <UserMembersListItemsContainer
      listBranch={currentBranch}
      listBranchState={currentBranchState}
      id={id}
      loadFromParent={loadFromParent}>

      {currentBrunchItems
        .map((item, index) => {

          const itemPath = [...path, item.id];
          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;

          return <div key={item.id}>
            <UserMembersListItem
              item={item}
              path={itemPath}
              checked={checkedValues[item.id] ?? false}
              rowSelected={selectedRows.some(row => row[row.length - 1] === item.id)}
              treeDepthLevel={path.length}
              isZebra={isZebraValue}
              selectRow={selectRow}
              addAction={addAction}
              translation={translation}
            />
            {open && <UserMembersListItems
              listBranch={listBranch}
              listBranchState={listBranchState}
              visiblity={visiblity}
              checkedValues={checkedValues}
              selectedRows={selectedRows}
              path={itemPath}
              isZebra={isZebraValue}
              selectRow={selectRow}
              addAction={addAction}
              loadFromParent={loadFromParent}
              translation={translation}
            />}
          </div>;
        })}
    </UserMembersListItemsContainer>
    {fetching && <UserMembersItemRow isZebra={isZebra} isLoader>
      <CodetableItemLoader>
        {translation.loading}
      </CodetableItemLoader>
    </UserMembersItemRow>}
  </>;
};
